import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Input } from 'components/common/FormElements/Input'

const CompatibilityForm = ({
  viewModel: {
    compatibility
  },
  compatibilityFilter,
  handleChange
}) =>
  <Fragment>
    <div>
      <Field
        { ...compatibility.compatible }
        component={ Input }
        checked={ compatibilityFilter === compatibility.compatible.value || !compatibilityFilter }
        onChange={ handleChange } />
    </div>
    <div>
      <Field
        { ...compatibility.incompatible }
        component={ Input }
        checked={ compatibilityFilter === compatibility.incompatible.value }
        onChange={ handleChange } />
    </div>
  </Fragment>

CompatibilityForm.propTypes = {
  compatibilityFilter: PropTypes.string,
  handleChange: PropTypes.func,
  viewModel: PropTypes.shape()
}

export default CompatibilityForm
